import * as React from 'react';
import { SVGProps } from 'react';

const IconGitHubSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.005 2C4.628 2 1.898 4.75 1.898 8.152c0 2.72 1.75 5.022 4.176 5.836.303.062.414-.132.414-.295 0-.143-.01-.631-.01-1.14-1.698.366-2.052-.734-2.052-.734-.273-.713-.678-.896-.678-.896-.556-.377.041-.377.041-.377.617.04.94.631.94.631.546.937 1.426.673 1.78.51.05-.398.212-.673.384-.825-1.355-.143-2.78-.673-2.78-3.036 0-.672.242-1.222.626-1.65-.06-.153-.273-.784.061-1.63 0 0 .516-.163 1.678.632a5.872 5.872 0 0 1 1.527-.204c.516 0 1.041.071 1.527.204 1.162-.795 1.678-.632 1.678-.632.334.846.121 1.477.06 1.63.395.428.628.978.628 1.65 0 2.363-1.426 2.883-2.79 3.035.222.194.414.56.414 1.141 0 .825-.01 1.487-.01 1.691 0 .163.11.357.414.296a6.147 6.147 0 0 0 4.176-5.837C14.112 4.75 11.372 2 8.005 2Z"
    />
  </svg>
);
export default IconGitHubSizeS;
